import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Archive, ChevronDown, ChevronRight } from "lucide-react";

const label = (ym) => new Date(`${ym}-01T00:00:00`).toLocaleDateString("en-IN", { month: "long", year: "numeric" });
const fmt = (s) => (s ? new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short" }) : "—");

export default function GstArchive() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState({});
  useEffect(() => { api.get("/tasks/gst-archive").then(r => { setData(r.data); setOpen({ [r.data.months[0]?.month]: true }); }); }, []);
  if (!data) return <div className="text-sm text-zinc-500 p-6" data-testid="gst-archive-loading">Loading archive…</div>;
  return (
    <div className="space-y-3" data-testid="gst-archive">
      <div className="text-xs text-zinc-500 flex items-center gap-2"><Archive size={13} /> Completed GST return tasks from earlier months, grouped by month. Only the last 3 months are retained; older filings are purged automatically.</div>
      {data.months.map(m => (
        <div key={m.month} className="border border-zinc-200 bg-white" data-testid={`gst-archive-month-${m.month}`}>
          <button onClick={() => setOpen(o => ({ ...o, [m.month]: !o[m.month] }))} className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-zinc-50" data-testid={`gst-archive-toggle-${m.month}`}>
            <span className="font-heading font-bold text-sm flex items-center gap-2">{open[m.month] ? <ChevronDown size={14} /> : <ChevronRight size={14} />}{label(m.month)}</span>
            <span className="text-xs text-zinc-500 tabular">{m.count} filed</span>
          </button>
          {open[m.month] && (
            <table className="w-full text-sm border-t border-zinc-100">
              <thead className="text-[10px] uppercase tracking-wider text-zinc-500 bg-zinc-50">
                <tr><th className="text-left px-4 py-2">Client</th><th className="text-left px-2 py-2">Return</th><th className="text-left px-2 py-2">Period</th><th className="text-left px-2 py-2">Due</th><th className="text-left px-2 py-2">Filed on</th><th className="text-left px-2 py-2">Executive</th></tr>
              </thead>
              <tbody>
                {m.tasks.map(t => (
                  <tr key={t.id} className="border-t border-zinc-100" data-testid={`gst-archive-row-${t.id}`}>
                    <td className="px-4 py-2 font-medium">{t.client_name}</td>
                    <td className="px-2 py-2">{t.form || t.service}</td>
                    <td className="px-2 py-2 text-zinc-600">{t.period || "—"}</td>
                    <td className="px-2 py-2 tabular">{fmt(t.deadline)}</td>
                    <td className="px-2 py-2 tabular text-emerald-700">{fmt(t.completed_at)}</td>
                    <td className="px-2 py-2 text-zinc-600">{t.assigned_employee_name}</td>
                  </tr>
                ))}
                {!m.tasks.length && <tr><td colSpan={6} className="px-4 py-6 text-center text-xs text-zinc-400">No completed GST returns stored for this month.</td></tr>}
              </tbody>
            </table>
          )}
        </div>
      ))}
    </div>
  );
}
